<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de transferências">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'almoxarifado-transferencia-create' })"
                    authorize="store-almoxarifado-transferencia"
                    color="primary"
                >
                    Cadastrar transferência
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/almoxarifado/transferencia/List'

export default {
    components: { List },
}
</script>